import * as THREE from 'three';

export class WebGPURenderer extends THREE.WebGLRenderer {
    context: WebGLRenderingContext | WebGL2RenderingContext | null;
    anisotropy: number;
    shadowMap = {
        enabled: false,
        autoUpdate: true,
        needsUpdate: false,
        type: THREE.PCFSoftShadowMap,
        render: () => { },
        cullFace: {},
        mapSize: 16384
    };
    constructor(o: THREE.WebGLRendererParameters | undefined) {
        super(o);
        this.init();
    }
    async init() {
        try {
            const adapter = await navigator.gpu.requestAdapter();
            const device = await adapter.requestDevice();
            this.context = null;
            this.context = this.getContext();
            this.context.gpu = device;
        } catch (e) {
            console.debug(e);
        }
    }
}
